import {ServiceConfig} from './service';

export const URL = {
  AdminRoot: '/admin',
  AgentRoot: '/agent',
  SearchResources: '/receiver/searchresources',
  GetExternalPartners: '/partners/external',
  SaveNewReceiverAccount: '/receiver/save',
  GetManageAccountDetail: '/account/detail',
  DeleteReceiverAccount: '/receiver/account/delete',
  GetReceiverList: '/receiver/list',
  DeleteReceiver: '/receiver/delete',
  SaveReceiverList: '/receiver/list/save',
  GetPayoutPartnerGroupList: '/partner/grouplist/payout',
};

export let Api = {
  Agent: {
    AMLCheck: ServiceConfig.endpoint + '/agent/aml/check',
    MyPage: ServiceConfig.endpoint + '/agent/mypage/confirm',
    MyPageUpdate: ServiceConfig.endpoint + '/agent/mypage/update',
    PasswordUpdate: ServiceConfig.endpoint + '/agent/password/update',
    Login: ServiceConfig.endpoint + '/agent/login',
    Logout: ServiceConfig.endpoint + '/agent/logout',
    Home: ServiceConfig.endpoint + '/agent/home',
    User: ServiceConfig.endpoint + '/agent/user',
    UserRegister: ServiceConfig.endpoint + '/agent/user/registration',
    UserCheck: ServiceConfig.endpoint + '/agent/user/registration/check',
    UserModify: ServiceConfig.endpoint + '/agent/user/update',
    UserModifyValid: ServiceConfig.endpoint + '/agent/user/updatevalid',
    UserValidateMobile: ServiceConfig.endpoint + '/agent/user/validate/mobile',
    UserReAuthMobile: ServiceConfig.endpoint + '/agent/user/validate/mobile/reauth',
    UserVerifyMobile: ServiceConfig.endpoint + '/agent/user/validate/mobile/verify',
    UserTransactionList: ServiceConfig.endpoint + '/agent/user/transaction/list',
    ResetFailedCount: ServiceConfig.endpoint + '/agent/user/reset/failed/',
    UserFileData: ServiceConfig.endpoint + '/agent/user/file/',
    UserCoi: ServiceConfig.endpoint + '/agent/customer/coi',
    UserStatistics: (id, year, type) => {
      return ServiceConfig.endpoint + '/agent/user/' + id + '/' + year + '/' + type + '/statistics';
    },
    UserRemittance: (id) => {
      return ServiceConfig.endpoint + '/agent/user/' + id + '/remittance';
    },
    Transaction: ServiceConfig.endpoint + '/agent/transaction',
    TransactionDetail: ServiceConfig.endpoint + '/agent/transaction/detail',
    TransactionHold: ServiceConfig.endpoint + '/agent/transaction/hold',
    TransactionCancel: ServiceConfig.endpoint + '/agent/transaction/cancel',
    TransactionApprove: ServiceConfig.endpoint + '/agent/transaction/approve',
    TransactionConfirm: ServiceConfig.endpoint + '/agent/transaction/confirmed',
    TransactionSender: ServiceConfig.endpoint + '/agent/transaction/send/sender',
    TransactionReceiver: (id) => {
      return ServiceConfig.endpoint + '/agent/transaction/send/sender/' + id + '/receiver';
    },
    TrnasactionCountry: ServiceConfig.endpoint + '/agent/transaction/send/country',
    TrnasactionPayoutBankByType: (partner, type) => {
      return ServiceConfig.endpoint + '/agent/transaction/send/' + partner + '/bank/' + type;
    },
    TransactionPayoutBranchByType: (partner, type) => {
      return ServiceConfig.endpoint + '/agent/transaction/send/' + partner + '/' + type;
    },
    PartnerDetail: (partner_id) => {
      return ServiceConfig.endpoint + '/agent/partner/' + partner_id;
    },
    BranchDetail: (branch_code) => {
      return ServiceConfig.endpoint + '/agent/branch/' + branch_code;
    },
    TransactionRate: ServiceConfig.endpoint + '/agent/transaction/send/rate',
    TransactionSave: ServiceConfig.endpoint + '/agent/transaction/send/save',
    TransactionValid: ServiceConfig.endpoint + '/agent/transaction/valid',
    LicenseBlur: ServiceConfig.endpoint + '/license/blur',
    KYCAddressState: ServiceConfig.endpoint + '/agent/address/states',
    KYCSearchAddressByZipCode: (zipcode) => {
      return ServiceConfig.endpoint + '/admin/address/' + zipcode
    },
    DepositAccountList: ServiceConfig.endpoint + '/agent/depositacc/list',
    DepositBranches: ServiceConfig.endpoint + '/agent/depositbranch/list',
    DepositAccountSave: ServiceConfig.endpoint + '/agent/depositacc/save',
    UserNationalityList: ServiceConfig.endpoint + '/agent/user/nationality/list',
    CustomerKycCount: ServiceConfig.endpoint + '/agent/kyc_count',
    Version: ServiceConfig.endpoint + '/version',
    AccountValidation: ServiceConfig.endpoint + '/agent/payoutaccount/validate',
    GetLoginHistory: ServiceConfig.endpoint + '/agent/loginhistory',
    GetBankDepositHistory: ServiceConfig.endpoint + '/agent/bankdepositlist',
    UpdateBankDepositHistory: ServiceConfig.endpoint + '/agent/update/bankdepositlist',
    GetDepositSlipInfo: ServiceConfig.endpoint + '/agent/depositslip',
    ExpiredCustomerList: ServiceConfig.endpoint + '/agent/expiredcustomers',
    GetServiceListByPartner(partner_id: string) {
      return ServiceConfig.endpoint + '/agent/servicelist/' + partner_id;
    },
    GetPayoutBranches: ServiceConfig.endpoint + '/agent/transaction/send/bankbranch',
    GetTxnInfoList: (type) => {
      return ServiceConfig.endpoint + '/agent/get/txninfolist/' + type;
    },
    SaveTxnFee: ServiceConfig.endpoint + '/agent/save/fee',
    GetExternalPartners: ServiceConfig.endpoint + URL.AgentRoot + URL.GetExternalPartners,
    GetReceiverList: ServiceConfig.endpoint + URL.AgentRoot + URL.GetReceiverList,
    DeleteReceiver: (index) => {
      return ServiceConfig.endpoint + URL.AgentRoot + URL.DeleteReceiver + '?' + 'index=' + index;
    },
    SaveBeneficiaryList: ServiceConfig.endpoint + URL.AgentRoot + URL.SaveReceiverList,
    GetTxnInfoFullList: ServiceConfig.endpoint + URL.AgentRoot + '/get/txninfolist',
    PayoutPartnerGroupList: ServiceConfig.endpoint + URL.AgentRoot + URL.GetPayoutPartnerGroupList,
    getCustomerSnsInfo : (agentId: string) => ServiceConfig.endpoint + "/agent/sns-info/" + agentId,
  },
  Admin: {
    AMLCheck: ServiceConfig.endpoint + '/admin/aml/check',
    Login: ServiceConfig.endpoint + '/admin/login',
    Logout: ServiceConfig.endpoint + '/admin/logout',
    Time: ServiceConfig.endpoint + '/admin/time',
    Home: ServiceConfig.endpoint + '/admin/home',
    PartnerDetail: (partner_id) => {
      return ServiceConfig.endpoint + '/admin/partner/' + partner_id;
    },
    FXPartner: ServiceConfig.endpoint + '/admin/fxrate/partners',
    FXPayoutPartner: ServiceConfig.endpoint + '/admin/fxrate/payoutpartners',
    FXCountryRates: (partner_id) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + partner_id + '/country';
    },
    FXCountryUpdate: (partner_id, idx) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + partner_id + '/country/' + idx + '/update';
    },
    FXPartnerUpdate: (partner_id, idx) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + partner_id + '/partner/' + idx + '/update';
    },
    FXPartnerRates: (partner_id) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + partner_id + '/partner';
    },
    FXPartnerRate: ServiceConfig.endpoint + '/admin/fxrate/partners/rate',
    FxNewCountryRate: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + partner_id + '/country/new';
    },
    FxNewPartnerRate: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + partner_id + '/partner/new';
    },
    FxDeleteRate: (rate_idx: string) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + rate_idx + '/delete';
    },
    SVCChargePartner: ServiceConfig.endpoint + '/admin/servicecharge/partners',
    SVCChargePayoutPartner: ServiceConfig.endpoint + '/admin/servicecharge/payoutpartners',
    SVCChargePartnerRates: (partner_id) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/partner';
    },
    SVCChargeCountryRates: (partner_id) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/country';
    },
    SVCCharge3rdPartyRates: (partner_id) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/3rdpartyagent';
    },
    SVCChargeCountryUpdate: (partner_id, idx) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/country/' + idx + '/update';
    },
    SVCChargePartnerUpdate: (partner_id, idx) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/partner/' + idx + '/update';
    },
    SVCCharge3rdPartyUpdate: (partner_id, idx) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/3rdpartyagent/' + idx + '/update';
    },
    SVCChargeNewCountryCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/country/new';
    },
    SVCChargeNewPartnerCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/partner/new';
    },
    SVCChargeNew3rdPartyCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/3rdpartyagent/new';
    },
    SVCChargeUpdateCountryCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/country/update';
    },
    SVCChargeUpdatePartnerCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/partner/update';
    },
    SVCChargeUpdate3rdPartyCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/3rdpartyagent/update';
    },
    SVCChargeListUpdateCountryCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/country/updatelist';
    },
    SVCChargeListUpdatePartnerCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/partner/updatelist';
    },
    SVCChargeListUpdate3rdPartyCharge: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/3rdpartyagent/updatelist';
    },
    SVCChargeDetailAll: (partner_id: string, target_id: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/target/' + target_id;
    },
    SVCChargeDelete: (idx: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + idx + '/delete';
    },
    SVCChargeDetail: (idx: string) => {
      return ServiceConfig.endpoint + '/admin/servicecharge/' + idx;
    },

    FxHistoryRemitters: ServiceConfig.endpoint + '/admin/fxrate/history/remitters',
    FxHistoryPartners: (partner_id: string) => {return ServiceConfig.endpoint + '/admin/fxrate/history/' + partner_id + '/partners'; },
    FxHistoryCountries: (partner_id: string) => {return ServiceConfig.endpoint + '/admin/fxrate/history/' + partner_id + '/countries'; },
    FxHistory: ServiceConfig.endpoint + '/admin/fxrate/history',
    ReportPartner: ServiceConfig.endpoint + '/admin/report/partners',
    ReportInbPartner: ServiceConfig.endpoint + '/admin/report/inbpartners',
    ReportPartnerDetail: (partner_id: string) => {
      return ServiceConfig.endpoint + '/admin/report/' + partner_id + '/settlement';
    },
    InbReportPartnerDetail: (partner_name: string, partner_country: string) => {
      return ServiceConfig.endpoint + '/admin/report/' + partner_name + '/' + partner_country + '/settlementInb';
    },
    CustomerList: ServiceConfig.endpoint + '/admin/customer',
    CustomerRegister: ServiceConfig.endpoint + '/admin/customer/registration',
    CustomerCheck: ServiceConfig.endpoint + '/admin/customer/registration/check',
    CustomerSimilarList: ServiceConfig.endpoint + '/admin/customer/similar/list',
    CustomerMerge: ServiceConfig.endpoint + '/admin/customer/merge',
    ResetFailedCount: ServiceConfig.endpoint + '/admin/customer/reset/failed/',
    CustomerAccountRegistration: ServiceConfig.endpoint + '/admin/customer/account/registration',
    CustomerAccountValidation: ServiceConfig.endpoint + '/admin/customer/account/validation',
    CustomerModify: ServiceConfig.endpoint + '/admin/customer/update',
    CustomerModifyValid: ServiceConfig.endpoint + '/admin/customer/updatevalid',
    CustomerStatistics: (id, year, type) => {
      return ServiceConfig.endpoint + '/admin/customer/' + id + '/' + year + '/' + type + '/statistics';
    },
    CustomerRemittance: (id) => {
      return ServiceConfig.endpoint + '/admin/customer/' + id + '/remittance';
    },
    CustomerValidateMobile: ServiceConfig.endpoint + '/admin/customer/validate/mobile',
    CustomerVerifyMobile: ServiceConfig.endpoint + '/admin/customer/validate/mobile/verify',
    CustomerBlock: ServiceConfig.endpoint + '/admin/customer/block',
    CustomerFileData: ServiceConfig.endpoint + '/admin/customer/file',
    CustomerCoi: ServiceConfig.endpoint + '/admin/customer/coi',
    Transaction: ServiceConfig.endpoint + '/admin/transaction',
    InbTransaction: ServiceConfig.endpoint + '/admin/transaction/inbound_history',
    InbTransactionDetail: ServiceConfig.endpoint + '/admin/transaction/inbound_detail',
    TransactionSubInf: ServiceConfig.endpoint + '/admin/transaction/subside_info',
    TransactionSubInfNew: ServiceConfig.endpoint + '/admin/transaction/subside_info/new',
    TransactionSubInfUpdate: ServiceConfig.endpoint + '/admin/transaction/subside_info/update',
    AMLCheckRemittance: ServiceConfig.endpoint + '/admin/inbound/check/remittance',
    TransactionPending: ServiceConfig.endpoint + '/admin/transaction/inbound/Pending',
    InbTransactionApprove: ServiceConfig.endpoint + '/admin/transaction/inbound/Approved',
    InbTransactionReadyToPay: ServiceConfig.endpoint + '/admin/transaction/inbound/ReadyToPay',
    InbTransactionCancelled: ServiceConfig.endpoint + '/admin/transaction/inbound/Cancelled',
    TransactionComment: ServiceConfig.endpoint + '/admin/transaction/inbound/comment',
    TransactionDetail: ServiceConfig.endpoint + '/admin/transaction/detail',
    TransactionGet: ServiceConfig.endpoint + '/admin/transaction/get',
    TransactionCancel: ServiceConfig.endpoint + '/admin/transaction/cancel',
    TransactionApprove: ServiceConfig.endpoint + '/admin/transaction/approve',
    TransactionForcedApprove: ServiceConfig.endpoint + '/admin/transaction/forcedapprove',
    TransactionSender: ServiceConfig.endpoint + '/admin/transaction/send/sender',
    TransactionCheckDetail: ServiceConfig.endpoint + '/admin/transaction/inbound/checkdetail',
    UserTransactionList: ServiceConfig.endpoint + '/admin/user/transaction/list',
    TransactionReceiver: (id) => {
      return ServiceConfig.endpoint + '/admin/transaction/send/sender/' + id + '/receiver';
    },
    TransactionCountry: ServiceConfig.endpoint + '/admin/transaction/send/country',
    TransactionPayoutBankByType: (partner, type) => {
      return ServiceConfig.endpoint + '/admin/transaction/send/' + partner + '/bank/' + type;
    },
    TransactionPayoutBranchByType: (partner, type) => {
      return ServiceConfig.endpoint + '/admin/transaction/send/' + partner + '/' + type;
    },
    BranchDetail: (partner_id, branch_code) => {
      return ServiceConfig.endpoint + '/admin/user/branch/' + partner_id + '/' + branch_code + '/detail';
    },
    TransactionSubInfDelete : (value: string) => {
      return ServiceConfig.endpoint + '/admin/transaction/subside_info/'+ value + '/delete';
    },
    BranchList: ServiceConfig.endpoint + '/admin/user/branch',
    BranchNew: ServiceConfig.endpoint + '/admin/user/branch/new',
    BranchUpdate: ServiceConfig.endpoint + '/admin/user/branch/update',
    AgentList: ServiceConfig.endpoint + '/admin/user/agent',
    AgentNew: ServiceConfig.endpoint + '/admin/user/agent/new',
    AgentUpdate: ServiceConfig.endpoint + '/admin/user/agent/update',
    AgentDetail: (id) => {
      return ServiceConfig.endpoint + '/admin/user/agent/' + id + '/detail';
    },
    TransactionRate: ServiceConfig.endpoint + '/admin/transaction/send/rate',
    TransactionSave: ServiceConfig.endpoint + '/admin/transaction/send/save',
    TransactionValid: ServiceConfig.endpoint + '/admin/transaction/valid',
    TransactionUpdate: ServiceConfig.endpoint + '/admin/transaction/update',
    TransactionEdit: ServiceConfig.endpoint + '/admin/transaction/edit',
    FIUReport: ServiceConfig.endpoint + '/admin/fiureport',
    FIUReportDetail: ServiceConfig.endpoint + '/admin/fiureport/detail',
    FIUReportBlock: ServiceConfig.endpoint + '/admin/fiureport/block',
    FIUReportExportExcel: ServiceConfig.endpoint + '/admin/fiureport/excel_export',
    DepositHistyoryList: ServiceConfig.endpoint + '/admin/deposit/list',
    DepositInfo: ServiceConfig.endpoint + '/admin/deposit/info',
    KYCAddressState: ServiceConfig.endpoint + '/admin/address/states',
    KYCSearchAddressByZipCode: (zipcode) => {
      return ServiceConfig.endpoint + '/admin/address/' + zipcode
    },
    DepositAccountList: ServiceConfig.endpoint + '/admin/depositacc/list',
    DepositBranches:{
      getDepositBranches: ServiceConfig.endpoint + '/admin/depositbranch/list',
      deleteDepositBranch(branch_idx: number) {
        return ServiceConfig.endpoint + '/admin/depositbranch/list/delete/' + branch_idx;
      },
      addDepositBranch: ServiceConfig.endpoint + '/admin/depositbranch/list',
      updateDepositBranch: ServiceConfig.endpoint + '/admin/depositbranch/list/update'
    },
    UserNationalityList: ServiceConfig.endpoint + '/admin/user/nationality/list',
    CustomerKycCount: ServiceConfig.endpoint + '/admin/kyc_count',
    Version: ServiceConfig.endpoint + '/version',
    Notice: ServiceConfig.endpoint + '/admin/notice',
    NoticeList: ServiceConfig.endpoint + '/admin/notice/list',
    NoticeInsert: ServiceConfig.endpoint + '/admin/notice/insert',
    NoticeUpdate: ServiceConfig.endpoint + '/admin/notice/update',
    NoticeDelete: ServiceConfig.endpoint + '/admin/notice/delete',
    NoticeAlwaysOptionUpdate: ServiceConfig.endpoint + '/admin/notice/updatelist',
    Push: ServiceConfig.endpoint + '/admin/push',
    PushList: ServiceConfig.endpoint + '/admin/push/list',
    PushInsert: ServiceConfig.endpoint + '/admin/push/insert',
    PushUpdate: ServiceConfig.endpoint + '/admin/push/update',
    PushDelete: ServiceConfig.endpoint + '/admin/push/delete',
    MobileVersion: ServiceConfig.endpoint + '/admin/mobile/version',
    MobileVersionList: ServiceConfig.endpoint + '/admin/mobile/version/list',
    MobileVersionInsert: ServiceConfig.endpoint + '/admin/mobile/version/insert',
    MobileVersionUpdate: ServiceConfig.endpoint + '/admin/mobile/version/update',
    MobileVersionDelete: ServiceConfig.endpoint + '/admin/mobile/version/delete',
    DepositAccountSave: ServiceConfig.endpoint + '/admin/depositacc/save',
    AccountValidation: ServiceConfig.endpoint + '/admin/payoutaccount/validate',
    GetLoginHistory: ServiceConfig.endpoint + '/admin/loginhistory',
    GetBankDepositHistory: ServiceConfig.endpoint + '/admin/bankdepositlist',
    UpdateBankDepositHistory: ServiceConfig.endpoint + '/admin/update/bankdepositlist',
    MapBankDepositHistory: ServiceConfig.endpoint + '/admin/bankdeposit/confirmmaptxn',
    MapBankDepositListHistory: ServiceConfig.endpoint + '/admin/bankdeposit/confirm/transactions',
    UpdateCustomerExtName: ServiceConfig.endpoint + '/admin/update/customer/extname',
    GetBankDepositAccounts: ServiceConfig.endpoint + '/admin/bankaccount/refresh',
    UpdateBankDepositAccounts: ServiceConfig.endpoint + '/admin/bankaccount/updateinfo',
    GetApiCallCnt: ServiceConfig.endpoint + '/admin/apicallcnt',
    BankDepositProgress: ServiceConfig.endpoint + '/admin/bankdepositprogress',
    GetDepositSlipInfo: ServiceConfig.endpoint + '/admin/depositslip',
    ExpiredCustomerList: ServiceConfig.endpoint + '/admin/expiredcustomers',
    GetServiceListByPartner(partner_id: string) {
      return ServiceConfig.endpoint + '/admin/servicelist/' + partner_id;
    },
    RefundDepositList: ServiceConfig.endpoint + '/admin/refunddepositlist',
    SaveDepositMemo: ServiceConfig.endpoint + '/admin/save/depositmemo',
    DisableDepositList: ServiceConfig.endpoint + '/admin/bankdepositlist/disable',
    UploadSanctionFile: ServiceConfig.endpoint + '/admin/upload/sanction/manual',
    FXListCountryUpdate: (partner_id) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + partner_id + '/country/update';
    },
    FXListPartnerUpdate: (partner_id) => {
      return ServiceConfig.endpoint + '/admin/fxrate/' + partner_id + '/partner/update';
    },
    MyPage: ServiceConfig.endpoint + '/admin/mypage/confirm',
    MyPageUpdate: ServiceConfig.endpoint + '/admin/mypage/update',
    PasswordUpdate: ServiceConfig.endpoint + '/admin/password/update',
    GetDepositPartners: ServiceConfig.endpoint + '/admin/inbound/deposit/partnerlist',
    GetPayoutBranches: ServiceConfig.endpoint + '/admin/transaction/send/bankbranch',
    GetTxnInfoFullList: ServiceConfig.endpoint + '/admin/get/txninfolist',
    GetTxnInfoList: (type) => {
      return ServiceConfig.endpoint + '/admin/get/txninfolist/' + type;
    },
    GetSancFileInfo: ServiceConfig.endpoint + '/admin/sanction/fileinfo',
    GetManageAccount: ServiceConfig.endpoint + '/admin/accounts/list',
    GetManageAccountDetail: ServiceConfig.endpoint + URL.AdminRoot + URL.GetManageAccountDetail,
    SaveTxnFee: ServiceConfig.endpoint + '/admin/save/lstxn/fee',
    SearchResources: ServiceConfig.endpoint + URL.AdminRoot + URL.SearchResources,
    GetExternalPartners: ServiceConfig.endpoint + URL.AdminRoot + URL.GetExternalPartners,
    SaveNewReceiverAccount: ServiceConfig.endpoint + URL.AdminRoot + URL.SaveNewReceiverAccount,
    DeleteReceiverAccount: ServiceConfig.endpoint + URL.AdminRoot + URL.DeleteReceiverAccount,
    DailyMailingLists: ServiceConfig.endpoint + '/admin/report/bok/daily/mailing',
    InsertDailyMailingList: ServiceConfig.endpoint + '/admin/report/bok/daily/mailing/insert',
    DeleteDailyMailingLists: ServiceConfig.endpoint + '/admin/report/bok/daily/mailing/delete',
    GetReceiverList: ServiceConfig.endpoint + URL.AdminRoot + URL.GetReceiverList,
    DeleteReceiver: (index) => {
      return ServiceConfig.endpoint + URL.AdminRoot + URL.DeleteReceiver + '?' + 'index=' + index;
    },
    SaveBeneficiaryList: ServiceConfig.endpoint + URL.AdminRoot + URL.SaveReceiverList,
    PayoutPartnerGroupList: ServiceConfig.endpoint + URL.AdminRoot + URL.GetPayoutPartnerGroupList,
    getCustomerSnsInfo : (agentId: string) => ServiceConfig.endpoint + "/admin/sns-info/" + agentId,
  },
  LianLian: {
    Agent: {
    TXNSet: ServiceConfig.endpoint + '/agent/lianlian/txn/update',
    KYCSet: ServiceConfig.endpoint + '/agent/lianlian/kyc/update',
    Home: ServiceConfig.endpoint + '/agent/lianlian/home',
    RefundList: ServiceConfig.endpoint + '/agent/lianlian/refund/list',
    updateRefundStatus: ServiceConfig.endpoint + '/agent/lianlian/refund/update',
    insertRefund: ServiceConfig.endpoint + '/agent/lianlian/refund/new',
    RefundDetail: (id) => {
      return ServiceConfig.endpoint + '/agent/lianlian/refund/' + id + '/detail';
    }
  },
  Admin: {
    TXNSet: ServiceConfig.endpoint + '/admin/lianlian/txn/update',
    KYCSet: ServiceConfig.endpoint + '/admin/lianlian/kyc/update',
    Home: ServiceConfig.endpoint + '/admin/lianlian/home',
    RefundList: ServiceConfig.endpoint + '/admin/lianlian/refund/list',
    updateRefundStatus: ServiceConfig.endpoint + '/admin/lianlian/refund/update',
    insertRefund: ServiceConfig.endpoint + '/admin/lianlian/refund/new',
    RefundDetail: (id) => {
      return ServiceConfig.endpoint + '/admin/lianlian/refund/' + id + '/detail';
    },
  }
  },
  Common: {
    session: ServiceConfig.endpoint + '/access/session',
    sessionInit: ServiceConfig.endpoint + '/access/session/initialize',
  }
};





// WEBPACK FOOTER //
// ./src/app/shared/config/api.ts